import {Component, ViewChild} from '@angular/core';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {Group} from './Group';
import {AdminDocumentTypesService} from './adminDocumentTypes.service';
import { ConfigService } from 'app/core-ui/abstract/services/config.service';

@Component({
  selector: 'adminDocumentTypes-grid',
  templateUrl: './adminDocumentTypes.component.html',
  providers: [AdminDocumentTypesService],
})
export class AdminDocumentTypesComponent extends BaseGridNoCookieComponent<AdminDocumentTypesService> {
  @ViewChild('formModal') public formModal: ModalDirective;
  @ViewChild('confirmUpdateModal')
  public confirmUpdateModal: ModalDirective;

  selectedType: any = '';
  descriptionForm: any;
  groupObject: Group;
  legalDocument: any;
  groups: any;
  docSafeList = [];
  groupsList = [];
  yesNoList = [];
  typesList = [];
  viewRole: any;
  subLobList = [];
  lookUpArray = [];
  localStorageKey: any;
  lookUpTable: any;
  lookUpColumn: any;
  action: any;
  showSubGroupField: boolean = false;
  isSubmitted: boolean = false;
  valMaxLength: any = 10;
  lang2Enabled = false;
  lang1Enabled = false;
  lang1IsRightToLeft = false;

  constructor(
    public gridService: AdminDocumentTypesService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    public configService: ConfigService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(securityService, logger, visualsService, gridService, 'newDocumentType');
    this.loadVisuals();
    this.lang2Enabled = configService.isLang2Enabled();
    this.lang1Enabled = configService.isLang1Enabled();
    this.lang1IsRightToLeft = configService.isLang1RightToLeft();
  }

  ngOnInit() {
    this.viewRole = this.securityService.isOtherStaff();
    this.typesList = this.visualsService.getLkpFromStorageAsJSON('LKP_ADM_PARAM_S_PARAM_CD', true);
    this.subLobList = this.visualsService.getLkpFromStorageAsJSON('LKP_COMPANY_ACTIVITY', true);
    this.groupsList = this.visualsService.getLkpFromStorageAsJSON(
      'LKP_CMP_DOC_GROUP_GENERAL_DOC_TYPE',
      true,
    );
    this.yesNoList = this.visualsService.getLkpFromStorageAsJSON('LKP_GENERIC_YN', true);
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.typesList = this.visualsService.getLkpFromStorageAsJSON(
          'LKP_ADM_PARAM_S_PARAM_CD',
          true,
        );
        this.subLobList = this.visualsService.getLkpFromStorageAsJSON('LKP_COMPANY_ACTIVITY', true);
        this.groupsList = this.visualsService.getLkpFromStorageAsJSON(
          'LKP_CMP_DOC_GROUP_GENERAL_DOC_TYPE',
          true,
        );
        this.yesNoList = this.visualsService.getLkpFromStorageAsJSON('LKP_GENERIC_YN', true);
      },
    });

    this.getAllCategories();
    this.getAllGroups();
  }

  getAllCategories() {
    this.loading = true;
    this.gridService.getAllCategories().subscribe({
      next: (data) => {
        this.lookUpArray = data.data;
        this.loading = false;
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  getAllGroups() {
    this.gridService.getGroups().subscribe({
      next: (data) => {
        this.groups = data.data;
        this.loading = false;
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  onCategoryChange() {
    this.loading = true;
    let splitted = this.selectedType.split('-');
    this.lookUpTable = splitted[0];
    this.lookUpColumn = splitted[1];
    this.syncLocalStorage();
    this.localStorageKey = 'LKP_' + this.lookUpTable + '_' + this.lookUpColumn;
  }

  onGroupChange(event) {
    this.descriptionForm.controls['docSafe'].setValue('');
    this.setGroupOptions(event.target.value);
  }

  setGroupOptions(val) {
    this.docSafeList = [];
    this.groupObject = Object.assign(
      {},
      this.groups.filter((item) => {
        return item.docType == val;
      })[0],
    );

    if (this.groupObject.docType) {
      //if has group, set possible subgroups
      this.setSubGroupOptions();
    } else {
      this.showSubGroupField = false;
    }
  }

  setSubGroupOptions() {
    this.descriptionForm.controls['docSafe'].setValidators(Validators.required);

    let hasMultipleValues =
      this.groupObject && this.groupObject.docSafe && this.groupObject.docSafe.includes('/');
    let splitted = this.groupObject.docSafe.split('/');
    splitted.forEach((item) => {
      let obj = {docSafe: item};
      this.docSafeList = [...this.docSafeList, obj];
      if (!hasMultipleValues) {
        this.descriptionForm.controls['docSafe'].setValue(item);
      }
    });
    this.showSubGroupField = hasMultipleValues;

    this.descriptionForm.controls['docSafe'].updateValueAndValidity();
  }

  openFormModal(action, id) {
    this.loading = true;
    this.isSubmitted = false;
    if (action === 'edit') {
      this.action = 'edit';
      this.getTypeByKey(id);
    } else {
      this.action = 'create';
      this.initForm(null);
    }
  }

  getTypeByKey(key) {
    this.loading = true;
    this.gridService.getDocumentTypeByKey(key, this.lookUpTable).subscribe({
      next: (data) => {
        this.initForm(data.data);
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  initForm(data) {
    this.valMaxLength = this.lookUpColumn == 'S_REP_POSITION' ? 3 : 10;
    let hasGroup = this.lookUpTable == 'REGCMP_DOCUMENT' ? true : false;

    this.descriptionForm = this.fb.group({
      val: [data ? data.val : '', [Validators.maxLength(this.valMaxLength), Validators.required]],
      engDesc: [data ? data.engDesc : '', [Validators.required, Validators.maxLength(200)]],
      grDesc: [data ? data.grDesc : '', this.lang1Enabled ? [Validators.required, Validators.maxLength(200)] : []],
      group: [data ? data.generalDocType : '', hasGroup ? [Validators.required] : []],
      lkupTable: [this.lookUpTable],
      docSafe: [data ? data.docSafe : '', hasGroup ? [Validators.required] : []],
      isOptional: [data ? data.isOptional : '', hasGroup ? [Validators.required] : []],
      lkupCol: [this.lookUpColumn],
      grLangId: ['1'],
      engLangId: ['2'],
    });

    if (hasGroup && data) {
      this.groupObject = new Group(
        data && data.generalDocType ? data.generalDocType : '',
        data && data.docSafe ? data.docSafe : '',
        data && data.docSafe ? data.docSafe : '',
      );

      this.setGroupOptions(data.generalDocType);
    } else {
      this.showSubGroupField = false;
    }

    this.loading = false;
    this.formModal.show();
  }

  deleteDoc(id) {
    this.loading = true;

    let params = {
      lkupTable: this.lookUpTable,
      lkupCol: this.lookUpColumn,
      val: id,
    };

    this.gridService.checkType(params).subscribe({
      next: (data) => {
        //if type can be altered then proceed to delete

        this.gridService.deleteDoc(id, this.lookUpTable).subscribe({
          next: (data) => {
            this.loading = false;
            LogService.emitAlert({
              type: 'success',
              body: data.message,
            });
            this.syncLocalStorage();
          },
          error: (error) => {
            this.logger.info(error);
            this.loading = false;
          },
        });
      },
      error: (error) => {
        this.logger.info(error);
        this.loading = false;
      },
    });
  }

  saveType() {
    this.isSubmitted = true;
    if (!this.descriptionForm.invalid) {
      this.loading = true;
      this.formModal.hide();
      if (this.selectedType == 'REG_COMPANY-S_SUB_LOB') {
        this.gridService.getSubLobSec().subscribe({
          next: (data) => {
            this.descriptionForm.controls.val.setValue(
              this.descriptionForm.controls.val.value + '.' + data.data,
            );
            this.submitMyForm();
          },
          error: (error) => {
            this.loading = false;
            this.logger.info(error);
            this.isSubmitted = false;
          },
        });
      } else {
        this.submitMyForm();
      }
    } else {
      return;
    }
  }

  submitMyForm(skipExistingCheck?: boolean) {
    let doesTypeExist = false;

    if (!skipExistingCheck && this.action === 'create') {
      doesTypeExist = this.checkIfTypeExists(this.descriptionForm.controls.val.value);
    }

    if (doesTypeExist) {
      this.formModal.hide();
      this.confirmUpdateModal.show();
      return;
    }

    this.loading = true;
    this.formModal.hide();

    this.gridService.saveDoc(this.descriptionForm.value).subscribe({
      next: (data) => {
        this.syncLocalStorage();

        LogService.emitAlert({
          type: 'success',
          body: data.message,
        });
        this.descriptionForm.reset();
        this.isSubmitted = false;
      },
      error: (error) => {
        this.loading = false;
        this.logger.info(error);
        this.isSubmitted = false;
      },
    });
  }

  confirmUpdateExisting(value) {
    if (value == 'Yes') {
      this.submitMyForm(true);
      this.confirmUpdateModal.hide();
      this.formModal.hide();
    } else {
      this.formModal.hide();
      this.confirmUpdateModal.hide();
      this.descriptionForm.reset();
      this.isSubmitted = false;
      this.loading = false;
    }
  }

  checkIfTypeExists(sVal) {
    //method to check if the the short desc. from a new type matches an old one --> want to update?
    var lookups = [];
    lookups = JSON.parse(
      localStorage.getItem(this.localStorageKey + '_' + this.gridService.getLangId()),
    );
    var isPresent = lookups
      ? lookups.some(function (el) {
          return el.id === sVal;
        })
      : false;

    return isPresent;
  }

  syncLocalStorage() {
    this.visualsService
      .getLookup(this.lookUpTable, this.lookUpColumn, this.gridService.getLangId())
      .subscribe({
        next: (data) => {
          this.legalDocument = data;
          localStorage.setItem(
            this.localStorageKey + '_' + this.gridService.getLangId(),
            JSON.stringify(this.legalDocument),
          );
          if (this.localStorageKey === 'LKP_COMPANY_ACTIVITY') this.subLobList = data;
          this.loading = false;
        },
        error: (error) => {
          this.logger.info(error);
          this.loading = false;
        },
      });
  }
}
